import { endOfDay } from 'date-fns';
import { ChangeEvent, FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DateRangeDropdown, DateRangeOptionId, DateRangeSelection, SearchBar } from '@builder';
import { getDateWithoutTZ } from '@common/utils';
import { COMMON_TRANSLATION, LAYOUT_THREE } from '@constants/index';

import { StyledDropdownFilters, StyledBasicFilter, StyledDateContainer } from './BasicFilter.styles';
import { BasicFilterProps } from './BasicFilter.types';

const BasicFilter: FC<BasicFilterProps> = ({ maxDate, onFilterChange }) => {
  const { t } = useTranslation([COMMON_TRANSLATION]);
  const [queryFilter, setQueryFilter] = useState<string>('');
  const [dateRangeFilter, setDateRangeFilter] = useState<DateRangeSelection | undefined>();

  const handleQueryFilterChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setQueryFilter(e?.target?.value);
  };

  const handleDateRangeSelect = (value: DateRangeSelection): void => {
    setDateRangeFilter({
      ...value,
      endDate: value?.endDate && endOfDay(value?.endDate),
    });
  };

  const handleQueryFilterClear = (): void => {
    setQueryFilter('');
  };

  useEffect(() => {
    onFilterChange({
      query: queryFilter,
      dateRange: dateRangeFilter,
    });
  }, [queryFilter, dateRangeFilter]);

  return (
    <StyledBasicFilter>
      <SearchBar
        id="filter-search"
        label={''}
        name="filter-search"
        width="400px"
        onChange={handleQueryFilterChange}
        onClear={handleQueryFilterClear}
      />
      <StyledDateContainer>
        <StyledDropdownFilters>
          <DateRangeDropdown
            value={{
              startDate: undefined,
              endDate: undefined,
              selectedDateRange: DateRangeOptionId.ALL_TIME,
            }}
            dateRangeErrorTitle={t('selected_date_range.error.title')}
            maxDate={maxDate ? new Date(getDateWithoutTZ(maxDate)) : undefined}
            onSelect={handleDateRangeSelect}
            showText={true}
            layout={LAYOUT_THREE}
          />
        </StyledDropdownFilters>
      </StyledDateContainer>
    </StyledBasicFilter>
  );
};

export default BasicFilter;
